import { uploadFile } from "../base.api.js";

export const uploadFileApi = async (file, companyName, mdsNumber, manualType, location) => {
    const response = await uploadFile('files/upload', file, {
        companyName: companyName,
        mdsNumber: mdsNumber,
        manualType: manualType,
        location: location
    });
    console.log('Upload response:', response);
    return response;
}